import { RevenueByMonthResponse } from 'services/requests';
import {
  EtzRevenueTableSign,
  MapData,
  columns,
} from 'screens/EtzProfile/EtzProfileRevenueTable/EtzProfileRevenueTable.columns';
import Table from 'components/Table';
import { AVALIABLE_ROWS_PER_PAGE } from 'components/Table/Table.constants';
import TableFooter from 'components/Table/TableFooter';

type RenderEtzProfileRevenueTableProps = {
  revenueByMonthData?: RevenueByMonthResponse;
  items?: MapData;
};

const RenderEtzProfileRevenueTable = ({
  revenueByMonthData,
  items,
}: RenderEtzProfileRevenueTableProps): JSX.Element | null => {
  if (!revenueByMonthData?.context || !items || (items && items?.length === 0))
    return null;

  return (
    <Table<EtzRevenueTableSign> columns={columns} data={items}>
      <TableFooter
        pages={revenueByMonthData.context.pages}
        totalRows={revenueByMonthData.context.totalRows}
        availableRowsPerPage={AVALIABLE_ROWS_PER_PAGE}
      />
    </Table>
  );
};

export default RenderEtzProfileRevenueTable;
